import { cn } from "@workspace/web-ui/lib/utils";
import { CircleCheck, Clock, Info, Stethoscope } from "lucide-react";

type StatusType = {
    tag?: string
    program?: string
}

export const ConsultationStatus = ({ tag, program }: StatusType) => {
    return (
      <>
        {program === "urgent-care" ? (
          <div className="flex gap-2 items-center">
            {/* First tag: Always "Consultation" */}
            <div
              className={cn(
                "flex flex-row gap-[2px] items-center rounded-[888px] px-[6px] py-[4px] w-fit",
                "text-[#7B238D] bg-[#7B238D26] border"
              )}
              data-testid="consultation-status"
            >
              <Stethoscope className="size-4 text-[#7B238D]" />
              <span className="text-xs font-medium">Consultation</span>
            </div>
            {/* Second tag: Dynamic based on status */}
            {tag === "Resolved" && (
              <span className="text-xs font-medium py-[2px] px-[6px] rounded-full text-[#16A34A] bg-[#ECFDF3] border border-[#BAE6C3] w-fit flex items-center gap-1">
                <CircleCheck className="size-[14px] text-[#16A34A]" />
                Resolved
              </span>
            )}
            {tag === "Fulfilled" && (
              <span className="text-xs font-medium py-[2px] px-[6px] rounded-full text-[#16A34A] bg-[#ECFDF3] border border-[#BAE6C3] w-fit flex items-center gap-1">
                <CircleCheck className="size-[14px] text-[#16A34A]" />
                Fulfilled
              </span>
            )}
            {tag === "Partially Fulfilled" && (
              <span className="text-xs font-medium py-[2px] px-[6px] rounded-full text-[#2563EB] bg-[#EFF6FF] border w-fit flex items-center gap-1">
                <Clock className="size-[14px] text-[#2563EB]" />
                Partially Fulfilled
              </span>
            )}
            {tag !== "Resolved" && tag !== "Fulfilled" && tag !== "Partially Fulfilled" && (
              <div
                className={cn(
                  "flex flex-row gap-1 items-center rounded-full px-[6px] py-[4px] w-fit",
                  "text-[#FFA726] bg-[#FFF5E6]"
                )}
                data-testid="consultation-status-action"
              >
                <Info className="size-4 text-[#FFA726]" />
                <span className="text-xs font-medium">Action needed</span>
              </div>
            )}
          </div>
        ) : (
          <div
            className={cn(
              "flex flex-row gap-[2px] items-center rounded-[888px] px-[6px] py-[4px] w-fit",
              "text-[#7B238D] bg-[#7B238D26] border"
            )}
            data-testid="consultation-status"
          >
            <Clock className="size-4 text-[#7B238D]" />
            <span className="text-xs font-medium">{tag || "Consultation"}</span>
          </div>
        )}
      </>
    );
  };